import React from 'react'
import defAvatar from "../../images/default avatar.jpg"
import { useState } from 'react'
import { NavLink } from 'react-router-dom'
import DashHeader from '../mini/DashHeader'
import { useDispatch, useSelector } from 'react-redux'
import { useUpdateProfileMutation, useUploadMediaMutation } from '../../redux/services/usersApi'
import { ClipLoader } from 'react-spinners'
import { toast } from 'react-toastify'
import { updateUser } from '../../redux/features/authSlice'
import { useRef } from 'react'
import CustomButton from '../mini/CustomButton'

const EditProfile = ({ activate }) => {

    const { user } = useSelector((state) => state.auth)
    const [ fullName, setName ] = useState(user?.fullName)
    const [ email, setEmail ] = useState(user?.email)
    const [ phone, setPhone ] = useState(user?.phone)
    const [updateLoading, setUpdateLoading] = useState(false)
    const [updateProfile] = useUpdateProfileMutation()
    const [uploadMedia, { isLoading: isMediaLoading }] = useUploadMediaMutation()
    const fileInput = useRef(null)
    const dispatch = useDispatch()

    const selectFile = () => {
        fileInput.current.click()
    }

    const uploadDp = async (e) => {
        const image = [...e.target.files]
        const filePath = e.target.value
        const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif|\.svg)$/i;

        if (!allowedExtensions.exec(filePath)) {
            toast.error('Invalid file type', {
                position: toast.POSITION.TOP_RIGHT
            })
            return false;
        }

        const fd = new FormData()
        fd.append("image", image[0])

        await uploadMedia(fd)
            .unwrap()
            .then((payload) => {
                // console.log(payload)
                const editObj = { fullName, email, phone, profilePictureUrl: payload.data.secure_url, profilePicturePID: payload.data.public_id }
                updateProfile(editObj)
                    .unwrap()
                    .then((resp) => {
                        // console.log('second api response', resp)
                        dispatch(updateUser(resp.data))
                    })
                    .catch(() => {
                        toast.error('Sorry, an error occured', {
                            position: toast.POSITION.TOP_RIGHT
                        })
                    })
            })
            .catch((error) => {
                toast.error('Sorry, an error occured', {
                    position: toast.POSITION.TOP_RIGHT
                })
                console.log(error)
            })
    }

    const handleInput = (e) => {
        switch (e.target.id) {
            case 'fullName':
            setName(e.target.value);
            break;
            
            case 'email':
            setEmail(e.target.value);
            break;
            
            case 'phone':
            setPhone(e.target.value);
            break;
            
            default:
            alert('sorry, unknown field');
            break;
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        const formData = { fullName, email, phone }
        setUpdateLoading(true)
        await updateProfile(formData)
            .unwrap()
            .then((payload) => {
                toast.success('Profile updated successfully', {
                    position: toast.POSITION.TOP_RIGHT
                })
                console.log(payload)
                dispatch(updateUser(payload.data))
                setUpdateLoading(false)
            })
            .catch((error) => {
                toast.error('Sorry, an error occured', {
                    position: toast.POSITION.TOP_RIGHT
                })
                console.log(error)
                setUpdateLoading(false)
            })

    }

    const tabClasses1 = "text-decoration-none ps-0 p-2 my-2 border-bottom-1 d-md-inline d-inline-block top-tab"
    const tabClasses2 = "text-decoration-none p-2 d-md-inline d-inline-block px-1 my-2 border-bottom-1 top-tab" 
    
    return (
        <>
            <DashHeader title="Admin Settings" />
            <nav className='mt-2 d-flex nav-tab'>
                <NavLink exact={"true"} to={"/dashboard/admin/edit-profile"} className={tabClasses1+" active-top-tab"}>
                    Edit Profile
                </NavLink>
                <span className="ps-0 p-2 d-md-inline d-none my-2 border-bottom-1 top-tab">
                </span>
                <NavLink exact={"true"} to={"/dashboard/admin/change-password"} className={({ isActive }) => isActive ? tabClasses2+" active-top-tab" : tabClasses2}>
                    Change Password
                </NavLink>
                <span className="ps-0 p-2 d-md-inline d-none px-5 my-2 border-bottom-1 top-tab">
                </span>
                <span className="ps-0 p-2 d-md-inline d-none px-5 my-2 border-bottom-1 top-tab">
                </span>
            </nav>
            <div className="pull-up">
                <div className="content row mt-5">
                    <div className="col-md-4 text-center">
                        <div className='edit-avatar-container'>
                            <img src={user?.profilePicture?.url || defAvatar} alt="" />
                            {isMediaLoading ? 
                            <div className={"media-loader"}>
                                <ClipLoader color='#FDC51C' />
                            </div> : ''
                            }
                            <svg onClick={selectFile} className='edit-icon' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="34" height="34"><path fill="none" d="M0 0h24v24H0z"/><path d="M15.728 9.686l-1.414-1.414L5 17.586V19h1.414l9.314-9.314zm1.414-1.414l1.414-1.414-1.414-1.414-1.414 1.414 1.414 1.414zM7.242 21H3v-4.243L16.435 3.322a1 1 0 0 1 1.414 0l2.829 2.829a1 1 0 0 1 0 1.414L7.243 21z" fill='rgba(113,110,110,1)'/></svg>
                            <input type="file" accept='image/*' onChange={uploadDp} ref={fileInput} style={{ display: 'none' }} />
                        </div>
                    </div>
                    <div className="col-md-8 my-3 my-md-0">
                        <form onSubmit={handleSubmit}>
                            <div className="form-group mb-4">
                                <label htmlFor="name" className="mb-2 fw-normal">Full Name</label>
                                <div className="input form-control w-50 w-md-100">
                                    <input type="text" id="fullName" className="w-100 p-2 px-0" onChange={handleInput} value={fullName} />
                                </div>
                            </div>

                        
                            <div className="form-group mb-4">
                                <label htmlFor="email" className="mb-2 fw-normal">Email Address</label>
                                <div className="input form-control w-50 w-md-100">
                                    <input type="email" id="email" disabled className="w-100 p-2 px-0" onChange={handleInput} value={email} />
                                </div>
                            </div>

                        
                            <div className="form-group mb-4">
                                <label htmlFor="phone" className="mb-2 fw-normal">Phone Number</label>
                                <div className="input form-control w-50 w-md-100">
                                    <input type="text" id="phone" className="w-100 p-2 px-0" onChange={handleInput} value={phone} />
                                </div>
                            </div>
                        
                            <CustomButton loading={updateLoading} width={"180px"} title={"Update Profile"} />
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}

export default EditProfile
